<template lang="html">
<section id="partners" class="padded" :class="loaded ? 'loaded' : ''">
	<div class="content content--card grid c-2">
		<div class="text">
			<h1 v-if="about[currentLang].partnersTitle" class="discret dark">{{ about[currentLang].partnersTitle }}</h1>
			<h1 v-else class="discret dark">{{ $t("partners") }}</h1>
			<p class="section-subtitle" v-html="about[currentLang].partners"></p>
		</div>
		<div>
			<ul class="flex" v-if="about[currentLang].partnersLogos.length">
				<li  v-for="(item, index) in about[currentLang].partnersLogos" :key="'logo'+index" :class="item.class">
					<img 
						v-if="Object.keys(item.logo).length"
						v-lazy="item.logo.url"
						:srcset="item.logo.srcset"
						sizes="(min-width: 1024px) 33.33333vw, (min-width: 1200px) 25vw, 50vw" 
						:alt="item.logo.alt ? item.logo.alt : item.logo.filename"/>
				</li>
			</ul>
		</div>
	</div>
</section>
</template>

<script>
import scrollBehavior  from '@/mixins/scrollBehavior.js'
import imgHandler  from '@/mixins/imgHandler.js'
import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
	mixins: [scrollBehavior, imgHandler, loaderHandler],
	props: ['about', 'site', 'currentLang'],
	watch:{
		visible(visible){
			if(visible){
				this.displayComponent(100);
			}
		},
	},
}
</script>

<style lang="scss">
	#partners{
		margin-top: 2.8rem;
		position:relative;
		@include transform(translate(0,10%));
		opacity:0;
		@include transition(transform .5s ease, opacity .3s ease);
		&.loaded{
			@include transform(translate(0,0));
			opacity:1;
			img{
				opacity:1;
			}
		}
		@media screen and (max-width:768px){
			margin-right:-2rem;
			width: 100%;
			padding:0;
			.text + div{
				margin-top:3rem;
			}
		}
		.content--card{
			z-index: 1;
			padding-bottom:2rem!important;
			.text{
				padding-top:2rem;
			}
		}
		.section-subtitle{
			p{
				max-width:450px;
			}
		}
		ul{
			align-items: center;
			@media screen and (min-width:1024px){
				margin: 0 -2.5rem;
			}
			li{
				margin-bottom:2rem;
				padding:0 1rem;
				@media screen and (min-width:1024px){
					padding:0 2.5rem;
				}
				img{
					opacity:0;
					@include transition(opacity .3s ease .5s);
					@media screen and (min-width:768px){
						margin-bottom:4.5rem;
						max-height: 90px;
						object-fit: contain;
						max-width:100%;
					}
				}
			}
		}
	}
</style>
